export default __webpack_public_path__ + "static/media/Like_Selected.e5f41ae0.svg";